import { FC, memo } from 'react'
import { Box, Card, Flex, Input, Radio, Text, useColorModeValue, useRadio } from '@chakra-ui/react'

type Props = any & {
  isCategorySelected: boolean
  badgeText: string
  label: string
  description: string
  color: string
  id: string
}

const CategoryCard: FC<Props> = ({ isCategorySelected, color, label, Icon, id, ...radioProps }) => {
  const { getInputProps, getRadioProps } = useRadio(radioProps)

  const categoryWeakColor = useColorModeValue(`${color}.200`, `${color}.800`)
  const categoryBorderColor = useColorModeValue(`${color}.500`, `${color}.300`)
  const defaultWeakColor = useColorModeValue('gray.200', 'gray.800')
  const defaultBorderColor = useColorModeValue('gray.500', 'gray.300')

  const weakColor = isCategorySelected ? categoryWeakColor : defaultWeakColor
  const borderColor = isCategorySelected ? categoryBorderColor : defaultBorderColor

  return (
    <Box as="label" cursor="pointer">
      <Input id={id} {...getInputProps({})} hidden />
      <Card
        {...getRadioProps()}
        className="accessible"
        bg={weakColor}
        opacity={isCategorySelected ? 1 : 0.8}
        borderWidth="2px"
        borderColor={isCategorySelected ? borderColor : 'borderColor  '}
        filter={isCategorySelected ? 'grayscale(0.4)' : 'grayscale(1)'}
        _hover={!isCategorySelected ? { opacity: 1 } : {}}
      >
        <Flex align="center" gap={2}>
          <Radio id={id} isChecked={isCategorySelected} size="sm" colorScheme={color} />
          <Icon />
          <Text fontSize="md">{label}</Text>
        </Flex>
      </Card>
    </Box>
  )
}

export default memo(CategoryCard)
